/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Round_Not_LiveInputs */



/**
* | output |
* | --- |
* | "That round is over — seating can only change in a live round" |
*
* @param {Err_Tournament_Round_Not_LiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_round_not_live = /** @type {((inputs?: Err_Tournament_Round_Not_LiveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Round_Not_LiveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette ronde est terminée — le placement ne peut changer que dans une ronde en cours")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esa ronda ya terminó — los asientos solo pueden cambiar en una ronda en progreso")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Essa rodada já terminou — os assentos só podem mudar em uma rodada em andamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Quel round è finito — i posti possono cambiare solo in un round in corso")
	return /** @type {LocalizedString} */ ("That round is over — seating can only change in a live round")
});